import React from 'react';
import { Card, Collapse } from 'antd';
import styled from 'styled-components';
import { AppWrappperHOC } from '../../Root/HOC';
import { Container } from '../../../components';
import { COLLAPSE_MCMD } from './constants';
import { constants } from '../../../devUtils';

const { Panel } = Collapse;

const StyledMcmd = styled.section`
  padding:20px 0px;
  .collapse-grill{
    .ant-collapse-item{
      border: none;
      .ant-collapse-header{
        color: ${(props) => props.theme.corellBlue};
      }
    }
  }
  ul{
    list-style:none;
    li{
      padding:8px 0px;
      font-size:16px;
      a{
        &:hover{
          color: ${(props) => props.theme.primaryColor};
        }
      }
    }
  }
`;

function MCMD() {
  const {
    DS_DETAILS,
  } = COLLAPSE_MCMD;
  return (
    <StyledMcmd>
      <Container>
        <Card className="rounded card-padding-20">
          <h2 className="text-red">Disclosures under Regulation 46 of the LODR</h2>
          <Collapse
            expandIconPosition="right"
            bordered={false}
            className="collapse-grill"
          >
            <div style={{ margin: '26px 16px 16px 0px' }}>
              <a
                href={constants.LINK_ZAGGLE_OVERVIEW}
                style={{
                  color: ' #000000',
                  fontSize: '16px',
                  border: 'none',
                  background: 'transparent',
                  margin: '16px 0px 16px 16px',
                }}
              >
                 (A) Details of Business
              </a>
            </div>
            {DS_DETAILS && DS_DETAILS.map(({ dsId, dsTitle, dsDataSlug }) => (
              <Panel
                header={<h2 className="font-16">{dsTitle}</h2>}
                key={dsId}
              >
                <ul>
                  { dsDataSlug && dsDataSlug.map(({ id, title, link }) => (
                    <li key={id}><a href={link} target="_blank">{title}</a></li>
                  ))}
                </ul>
              </Panel>
            ))}
          </Collapse>
        </Card>
      </Container>
    </StyledMcmd>
  );
}

const component = AppWrappperHOC(MCMD);

export { MCMD };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/DisclosuresRegulation/index.js